import useLocalStore from '../../../hooks/useLocalStore';
import FJHeaderConfig from '../../../config/FJHeaderConfig';
import { useMemo, useCallback } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import { LOCAL } from '../../../constants/FJEvnConstant';
import FJMobileHeader from './FJMobileHeader';
import { useSelector, useDispatch } from 'react-redux';
import { setSliceIsShowMobileHistory } from '../../../redux/slices/FJSliceCommon';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import FJActionLimitedCoupon from '../../../redux/action/FJActionLimitedCoupon.js';
import FJConstant from '../../../constants/FJConstant.js';
const environment = import.meta.env.MODE;
const isLocal = environment === LOCAL;

const FJMobileHeaderContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const creditNumber = useSelector(state => state.common.creditNumber);
    const isLogin = useSelector(state => state.common.isLogin);
    const isShowMobileGiftBtu = useSelector(state => state.common.isShowMobileGiftBtu);

    const curLag = FJLocalStore.currentTag();
    const _getHref = useCallback(
        href => {
            return isLocal ? href.replace('/apply', '') : `/${curLag}${href}`;
        },
        [curLag],
    );
    const aiToolList = useMemo(() => {
        return FJHeaderConfig.mobileMenuList.map(item => ({
            title: item.title,
            href: _getHref(item.href),
            icon: item.icon,
        }));
    }, [_getHref]);
    const onHistoryClick = useCallback(() => {
        dispatch(setSliceIsShowMobileHistory(true));
    }, [dispatch]);
    const _getCredits = useCallback(() => {
        dispatch(FJActionCommon.getCreditsAction());
    }, [dispatch]);

    const _getGiftBtu = useCallback(() => {
        dispatch(FJActionLimitedCoupon.openDiscountPanelAction({ fromType: FJConstant.DISCOUNT }));
    }, [dispatch]);

    return (
        <FJMobileHeader
            aiToolList={aiToolList}
            onHistoryClick={onHistoryClick}
            creditNumber={creditNumber}
            isLogin={isLogin}
            getCredits={_getCredits}
            isShowGiftBtu={isShowMobileGiftBtu}
            getGiftBtu={_getGiftBtu}
        />
    );
};

export default FJMobileHeaderContainer;
